import { QueryKeys } from "./query-client";
import { useQuery } from "react-query";
import { useVideoMeetingStore } from "../../components/config/store/useVideoMeetingStore";
import { VideoMeeting } from "../../constants/model/models";
import { BACKEND_URL } from "../../constants/env";

export function useVideoMeeting() {
  const { id, setId } = useVideoMeetingStore((state) => state);

  const {
    data: meeting,
    isFetching: meetingIsLoading,
    isError: meetingError,
  } = useQuery([QueryKeys.VIDEO_MEETING, id], () => getEntry(), {
    keepPreviousData: true,
    enabled: typeof id !== "undefined",
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  // wrap entry subscription into a promise to be used with react-query
  async function getEntry(): Promise<VideoMeeting> {
    const url = `${BACKEND_URL}/videomeeting?id=${id}`;

    const response = await fetch(url, {
      headers: {
        "Content-type": "application/json",
      },
    });

    return await response.json();
  }

  return { meetingError, meeting, meetingIsLoading, setId };
}
